/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Mixdown_LabelInputs */



/**
* | output |
* | --- |
* | "Export Mixdown" |
*
* @param {Audio_Description_Export_Mixdown_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_mixdown_label = /** @type {((inputs?: Audio_Description_Export_Mixdown_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Mixdown_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter le mixdown")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export Mixdown")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta Mixdown")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспортная смесь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación Mixdown")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口混合")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ミックスダウンのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्सपोर्ट मिक्सडाउन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mixdown de exportação")
	return /** @type {LocalizedString} */ ("Export Mixdown")
});